module.exports = __webpack_public_path__ + "static/img/case_banner_17_h5.4b51176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_17_h5.png
// module id = EgO4
// module chunks = 34